"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "x 알림 x": ""
};